// extracted by mini-css-extract-plugin
module.exports = {"ExpedientDetailsWrapper":"ExpedientConsultation_ExpedientDetailsWrapper__2l_QZ","primaryCardWrapper":"ExpedientConsultation_primaryCardWrapper__1vLNr"};